(function () {
  function updateCardFromSwatch(swatch) {
    const card = swatch.closest('.product-variant-tabs__card');
    if (!card) return;

    card.querySelectorAll('.product-variant-tabs__swatch').forEach((item) => {
      const isActive = item === swatch;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    const variantUrl = swatch.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('.js-pvt-card-link').forEach((link) => {
        link.href = variantUrl;
      });
      card.querySelectorAll('.js-pvt-choose-options[data-product-url]').forEach((button) => {
        button.setAttribute('data-product-url', variantUrl);
      });
    }

    const variantInput = card.querySelector('.js-pvt-variant-input');
    if (variantInput && swatch.dataset.variantId) {
      variantInput.value = swatch.dataset.variantId;
    }

    const primaryImage = card.querySelector('.js-pvt-primary-img');
    if (primaryImage && swatch.dataset.primarySrc) {
      primaryImage.src = swatch.dataset.primarySrc;
      if (swatch.dataset.primarySrcset) primaryImage.srcset = swatch.dataset.primarySrcset;
    }

    const hoverWrap = card.querySelector('.product-variant-tabs__img-wrap--hover');
    const hoverImage = card.querySelector('.js-pvt-hover-img');
    if (hoverWrap && hoverImage) {
      if (swatch.dataset.hoverSrc) {
        hoverImage.src = swatch.dataset.hoverSrc;
        hoverImage.srcset = swatch.dataset.hoverSrcset || '';
        hoverWrap.removeAttribute('hidden');
        card.classList.add('product-variant-tabs__card--media-hover');
      } else {
        hoverWrap.setAttribute('hidden', '');
        card.classList.remove('product-variant-tabs__card--media-hover');
      }
    }

    const price = card.querySelector('.js-pvt-price');
    if (price && swatch.dataset.price) price.innerHTML = swatch.dataset.price;

    const compare = card.querySelector('.js-pvt-compare');
    if (compare) {
      if (swatch.dataset.compare) {
        compare.innerHTML = swatch.dataset.compare;
        compare.classList.remove('hidden');
      } else {
        compare.innerHTML = '';
        compare.classList.add('hidden');
      }
    }

    const discount = card.querySelector('.js-pvt-discount');
    if (discount) {
      const pct = parseInt(swatch.dataset.discountPct || '0', 10);
      if (pct > 0) {
        discount.textContent = `${pct}% OFF`;
        discount.dataset.pct = String(pct);
        discount.classList.remove('hidden');
      } else {
        discount.textContent = '';
        discount.dataset.pct = '0';
        discount.classList.add('hidden');
      }
    }

    if (swatch.dataset.price) {
      card.dataset.filterPrice = swatch.dataset.price;
    }
  }

  function initProductTabSlider(root) {
    if (!root || root.dataset.productTabSliderReady === 'true') return;
    root.dataset.productTabSliderReady = 'true';

    const tabs = Array.from(root.querySelectorAll('.product-tab-slider__tab[data-tab-index]'));
    const panels = Array.from(root.querySelectorAll('.product-tab-slider__panel[data-tab-index]'));

    function updateArrows(panel) {
      const viewport = panel.querySelector('.product-tab-slider__viewport');
      const prev = panel.querySelector('.product-tab-slider__arrow--prev');
      const next = panel.querySelector('.product-tab-slider__arrow--next');
      if (!viewport || !prev || !next) return;

      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      prev.setAttribute('aria-disabled', viewport.scrollLeft <= 2 ? 'true' : 'false');
      next.setAttribute('aria-disabled', viewport.scrollLeft >= maxScroll - 2 ? 'true' : 'false');
    }

    function showPanel(index) {
      panels.forEach((panel) => {
        const isActive = panel.dataset.tabIndex === String(index);
        panel.classList.toggle('is-active', isActive);
        panel.toggleAttribute('hidden', !isActive);

        if (isActive) {
          const viewport = panel.querySelector('.product-tab-slider__viewport');
          if (viewport) viewport.scrollLeft = 0;
          window.requestAnimationFrame(() => updateArrows(panel));
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (tab.disabled) return;
        const index = tab.dataset.tabIndex;

        tabs.forEach((item) => {
          const isActive = item.dataset.tabIndex === String(index);
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        showPanel(index);
      });
    });

    panels.forEach((panel) => {
      const viewport = panel.querySelector('.product-tab-slider__viewport');
      const track = panel.querySelector('.product-tab-slider__track');
      const prev = panel.querySelector('.product-tab-slider__arrow--prev');
      const next = panel.querySelector('.product-tab-slider__arrow--next');
      if (!viewport || !track || !prev || !next) return;

      function cardStep() {
        const card = track.querySelector('.product-variant-tabs__card');
        if (!card) return viewport.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).gap) || 18;
        return Math.round(card.getBoundingClientRect().width + gap);
      }

      prev.addEventListener('click', () => {
        viewport.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        viewport.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });

      viewport.addEventListener('scroll', () => updateArrows(panel), { passive: true });
      window.addEventListener('resize', () => updateArrows(panel));
      updateArrows(panel);
    });

    root.addEventListener('click', (event) => {
      const swatch = event.target.closest('.product-variant-tabs__swatch');
      if (!swatch || !root.contains(swatch)) return;
      updateCardFromSwatch(swatch);
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-product-tab-slider]').forEach(initProductTabSlider);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('.product-variant-tabs__swatch');
    if (!swatch || swatch.closest('[data-product-tab-slider]')) return;
    updateCardFromSwatch(swatch);
  });
})();
